import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  questionnaireComponents,
  Loader,
} from "../../components";

import "./styles.css";

const Facilities = ({ setPage }) => {
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);
  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [state, setState] = useState({
    uniAcommodationImportance: "",
    uniTransportImportance: "",
  });

  useEffect(() => {
    setState({
      uniAcommodationImportance: questionnaire?.uniAcommodationImportance ?? "",
      uniTransportImportance: questionnaire?.uniTransportImportance ?? "",
    });
  }, [questionnaire]);

  const handleNext = () => {
    if (!state.uniAcommodationImportance || !state.uniTransportImportance) {
      message.error("Please fill all the required fields.");
    } else {
      const payload = { userId: profileData?.id, ...state };

      dispatch(
        QuestionnaireAction.addQuestionnaire(payload, (res) => {
          if (res.status === 200) {
            setPage("Demographics");
          }
        })
      );
    }
  };

  return (
    <div className="text-black">
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="1. How important is university accommodation for you?"
            required
          />
          <Spacer height={10} />
          <questionnaireComponents.QuestionnaireCircleInput
            value={state?.uniAcommodationImportance}
            handleChange={(e) =>
              setState({ ...state, uniAcommodationImportance: e })
            }
          />
          <Spacer height={24} />
          <questionnaireComponents.QuestionnaireLabel
            text="2. How important is it for the university to have their own transport
             service?"
            required
          />
          <Spacer height={10} />
          <questionnaireComponents.QuestionnaireCircleInput
            value={state?.uniTransportImportance}
            handleChange={(e) =>
              setState({ ...state, uniTransportImportance: e })
            }
          />
          <Spacer height={20} />
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                onClick={handleNext}
                size="large"
                width="full"
              >
                Next
              </Buttons.DefaultButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Facilities;
